import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery } from 'react-query'
import { fetchOfficeUserAssignments } from '@dc-shared-web/hooks/api/office/fetchOfficeUserAssignments'
import { AssignmentUser } from '@dc-shared-web/hooks/api/assignment'

export const useOfficeUserAssignments = ({
  officeUUID,
  projectId,
}: {
  officeUUID: string
  projectId?: string
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<AssignmentUser[], Error>(
    ['office', officeUUID, projectId, 'user-assignments'],
    async () => {
      const data = await fetchOfficeUserAssignments(apiClient, {
        officeUUID,
        projectId,
      })

      /* Sort by firstname and lastname. */
      const nextUserAssignments = data?.length ? [...data] : []
      nextUserAssignments.sort((a, b) => {
        const firstNameA = a.firstname.toLowerCase()
        const lastNameA = a.lastname.toLowerCase()

        const firstNameB = b.firstname.toLowerCase()
        const lastNameB = b.lastname.toLowerCase()

        const aName = `${firstNameA} ${lastNameA}`
        const bName = `${firstNameB} ${lastNameB}`

        return aName.localeCompare(bName)
      })

      return nextUserAssignments
    }
  )
}
